<template>
    <v-container v-if="menu" fluid grid-list-sm class="home">

      <div v-if="ef_loading"  style="z-index: 99999999 !important;position: fixed; top: 0; left: 0;background-color: #ffffff;width: 100%;height: 100%;">
        <br>
        <br>
        <br>
        <h1 class="justify-self-center"><v-progress-circular
            class="mr-1"
            indeterminate
            color="primary"
        ></v-progress-circular> Loading...</h1>
      </div>

<!--        <div class="text-xs-center mt-4 blue&#45;&#45;text"><h2><v-icon class="blue&#45;&#45;text">mdi-magnify</v-icon>  ค้นหาเมนู</h2></div>-->
        <v-layout row wrap class="mb-4">
            <v-flex xs12 sm8 md6 offset-md3 offset-sm2>
                <v-text-field
                        @keyup="searchMenu($event)" @keypress.enter="searchMenu()"  name="search" class="input" placeholder="Search.." v-model="search_val"  hint="* ค้นหาชื่อเมนูระบบที่ต้องการค้นหา" autocomplete="off"
                        persistent-hint
                ></v-text-field>
            </v-flex>
        </v-layout>

        <template v-for="(menu_item,i) in menuGroup">
            <v-divider v-if="i" class="mt-4"/>
            <h1 class="text-lpn my-3" style="text-shadow: 1px 1px 2px #ccc;position: relative">
                {{ menu_item.menu_group_name }}
            </h1>
            <v-layout row wrap align-start justify-start fill-height class="mt-3">
                <template v-for="(item) in getMenuById(menu_item.menu_group_id)">
                    <v-flex xs4 sm3 md2 class="align-start pa-2 my-2 each_menu text-xs-center" @click="redirect_page(item)">
                        <v-avatar size="80" :title="item.menu_name" :class="item.menu_avatar_class ? item.menu_avatar_class:' menu_title_default' " style="border: 1px solid #cdcdcd">
                            <v-img v-if="item.menu_icon_img " :src="(item.menu_icon_img_type == 'url' ? item.menu_icon_img:require('@/assets/img/'+item.menu_icon_img))">
                                <v-icon v-if="item.menu_icon" :class="item.menu_icon_class">
                                    {{ item.menu_icon }}
                                </v-icon>
                            </v-img>
                            <v-icon v-else-if="item.menu_icon && item.menu_icon_img" :class="item.menu_icon_class">
                                {{ item.menu_icon }}
                            </v-icon>
                            <v-img v-else :src="require('@/assets/img/logo/124x124.png')" contain/>
                        </v-avatar>
                        <div :class="'mt-2 font-weight-bold '+item.menu_class">
                            <span class="text--black text--darken-1" style="font-size: 0.95em">{{ item.menu_name }}</span>
                        </div>
                    </v-flex>
                </template>
            </v-layout>
        </template>

    </v-container>
</template>

<script>
// @ is an alias to /src
import EventBus from '@/EventBus'
import base64 from 'base-64'
import axios from "@/axios";

export default {
    name: 'OtherMenu',
    data() {
        return {
            userId: '',
            menu: null,
            menu_real: null,
            menu_access: null,
            search_val:'',
            ef_loading: false,
        }
    },
    created() {
    },
    mounted() {
        EventBus.$emit('set_navigation', {title: 'Service Excellence'})
        let localitem = this.getLocalItem()
        if (localitem && localitem.user_id) {
            this.userId = localitem.user_id
            this.getMenu()
        }
    },
    computed:{
        menuGroup(){
            let menu_array = [...this.menu]
            let flags = [], output = [], l = menu_array.length, i
            for (i = 0; i < l; i++) {
                if (flags[menu_array[i].menu_group_id]){
                    continue
                }
                flags[menu_array[i].menu_group_id] = true
                output.push({menu_group_id:menu_array[i].menu_group_id, menu_group_name:menu_array[i].menu_group_name})
            }
            return output
        },
    },
    methods: {
        searchMenu(event){
            if(event){
                this.search_val = event.target.value
            }
            this.menu = [...this.menu_real].filter(m => m.menu_name.trim().toLowerCase().includes(this.search_val.trim().toLowerCase()))
        },
        getMenuById(mid){
            return [...this.menu].filter(m => {
                return  m.menu_group_id == mid
            })
        },
        checkMenuCanAccess(){
            //Check user can access menu
            const menuByRole = [...this.menu].filter(async m => {
                let can_access = true
                if(m.menu_code){
                    can_access =  await this.checkPermission(m.menu_code,'CAN_ACCESS')
                }
                console.log(m.menu_name,can_access)
                return  can_access
            })
            console.log(menuByRole)
        },
        async getMenu(){
            try {
              const uri = '/getMenu?other_menu=1'
              const res = await axios.get(uri)
              if (res){
                //Check user can access menu
                let menu_can_access = []
                const menuPromise = [...res.data.result].map(async m => {
                  let can_access = true
                  if(m.menu_code){
                    can_access =  await this.checkPermission(m.menu_code,'CAN_ACCESS')
                  }
                  if(can_access){
                    menu_can_access.push(m)
                  }
                })
                await Promise.all(menuPromise)

                this.menu  = [...menu_can_access]
                this.menu_real  = [...menu_can_access]
              }
            } catch (err) {
              console.log(err.message)
            }
          },
          async redirect_page(menu_prop) {
            // console.log(menu_prop)
            let menu_redirect = menu_prop.menu_route_name
            let params = {}

            if (!menu_prop.menu_route_name) {
              if(menu_prop.menu_uri_link) {
                let user_id = this.userId
                if (menu_prop.menu_uri_link.indexOf('<userId>') !== -1) {
                  menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<userId>', user_id)
                }
                if (menu_prop.menu_uri_link.indexOf('<userId64>') !== -1) {
                  menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<userId64>', base64.encode(user_id))
                }


                //----- Auth Token -----------------------------------------------------------------//

                if (menu_prop.menu_uri_link.indexOf('<TokenAuthApi>') !== -1) {
                  this.ef_loading = true;
                  let TokenData = await this.GetTokenLoginSystem(user_id,menu_prop.skd01,menu_prop.skd02);
                  this.ef_loading = false;

                  if(!TokenData){
                    alert('Authentication failed');
                    return false;
                  }

                  menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<TokenAuthApi>', TokenData);

                }

                if (menu_prop.menu_uri_link.indexOf('<TokenAuthApiV2>') !== -1) {
                  this.ef_loading = true;
                  let TokenData = await this.GetTokenLoginSystem(user_id,menu_prop.skd01,menu_prop.skd02);
                  this.ef_loading = false;

                  if(!TokenData){
                    alert('Authentication failed');
                    if(menu_prop.url_login_error && menu_prop.url_login_error != ''){
                      window.location=menu_prop.url_login_error;
                    }
                    return false;
                  }

                  //ไปที่ url เลย กด back ไม่ได้
                  window.location.replace(menu_prop.menu_uri_link.replace('<TokenAuthApiV2>', TokenData));
                  return false;

                }

                if (menu_prop.menu_uri_link.indexOf('<LPPTokenAuthApiV2>') !== -1) {
                  this.ef_loading = true;
                  let TokenData = await this.GetTokenLoginLPPSystem(user_id);

                  this.ef_loading = false;

                  if(!TokenData){
                    alert('Authentication failed');
                    if(menu_prop.url_login_error && menu_prop.url_login_error != ''){
                      window.location=menu_prop.url_login_error;
                    }
                    return false;
                  }

                  //ไปที่ url เลย กด back ไม่ได้
                  window.location.replace(menu_prop.menu_uri_link.replace('<LPPTokenAuthApiV2>', TokenData));
                  return false;

                }

                //-------- END -------------------------------------------------------------------//

                if (menu_prop.menu_uri_link.indexOf('<jwt>') !== -1) {
                    const jwt_obj  = localStorage.getItem('svea_emp') ? JSON.parse(localStorage.getItem('svea_emp')): null
                    if(jwt_obj){
                        menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<jwt>',jwt_obj.token)
                    }else{
                        menu_prop.menu_uri_link = "";
                    }
                }
                params.external_link = 1
                menu_redirect = menu_prop.menu_uri_link
              } else {
                alert('พบกันเร็วๆ นี่')
              }
            }

            this.gotoRoute(menu_redirect, params, {
                nextFn: [
                    {
                        fnName: 'clickSaved',
                        data: {
                            menu_id: menu_prop.menu_id
                        }
                    }
                ]
            });

        }
    }
}
</script>

<style>
.menu_title {
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 1px 1px 5px #888;
}
.each_menu {
    border: 1px solid transparent;
    box-shadow: 1px 1px 5px transparent;
    cursor: pointer;
}
.each_menu:hover {
    border-radius: 5px;
    border: 1px solid #fff;
    box-shadow: 1px 1px 10px #555;
    background: #ffffff;
}

.menu_title_default {
    background: #0032a0 !important;
    border-color: #0032a0 !important;
    color: #fff;
}

.text-lpn{
    color: #0032a0;
}
</style>
